const contractRouter = [
  {
    path: '/contract/e-contract/:cid/:token',
    name: 'eContract',
    component: () => import('@/views/wxapp/components/eContract'),
    meta: {
      title: '合同签约'
    },
    props: true
  },
  {
    path: '/e-contract-completed/:cid/:token',
    name: 'completed',
    component: () => import('@/views/wxapp/components/eContract/completed.vue'),
    meta: {
      title: '合同详情'
    },
    props: true
  },
  {
    path: '/contract/e-contract-sendemail/:cid/:token/:email',
    name: 'sendEmail',
    component: () => import('@/views/wxapp/components/eContract/sendEmail.vue'),
    meta: {
      title: '发送邮件'
    },
    props: true
  },
  {
    path: '/contract/offlineInfo/:cid',
    name: 'offlineInfo',
    component: () => import('@/views/wxapp/components/eContract/offlineInfo.vue'),
    meta: {
      title: '合同详情'
    },
    props: true
  },
  {
    path: '/contract/e-contract-emailcompleted/:cid/:token',
    name: 'sendEmailCompleted',
    component: () => import('@/views/wxapp/components/eContract/sendEmailCompleted.vue'),
    meta: {
      title: '邮件发送成功'
    },
    props: true
  }
]
export default contractRouter
